<div class="wrapper">

        <app-navbar  (onViewInit)='onNavbarOk()'></app-navbar>
      
        <app-main-sidebar (onViewInit)='onSidebarOk()'></app-main-sidebar>
      
        <div class="" [ngClass]="{ 'content-wrapper':  true }"> 
            <!-- Content Header (Page header) -->
            <app-content-header></app-content-header>
      
            <!-- Main content -->
            <div class="content">
                  <router-outlet></router-outlet>
            </div>
            <!-- /.content -->
        </div>

        <app-main-footer (onViewInit)='onFooterOk()'></app-main-footer>
      
</div>
